import * as React from "react";
import * as Glob from "../Globale";
import * as Dati from "../Dati";
import * as Data from "../Data";
import * as DatiRCP from "../DatiRCP";
import {
    ChiamaAPI,
    Trad,
    BaseComponent,
    Tipo,
    BottoneAPI,
    CampiPolizza,
    InputData,
    AccordionAnagrafica,
    AccordionCampiPolizza,
    AccordionGaranzie,
    AccordionProdotti
} from "../components/";
import { ConnectedFields, IConnectedField, ProductTypeIdsExceptions, ProductTypeIdsAdd } from "../components/RCP/config";
import { CGaranzia } from "../DatiRCP";
import { CCampiMultiInfoDati } from "../components/CampoMultiInfo";
import moment from "moment";
import ChiamaWeb, { CChiamaWebParametri } from "../ChiamaWeb";

interface IRCPComparatoreState {
    Caricamento: boolean;
    //TODO Usare questo nello stato o la variabile interna alla classe?
    Aggiornare: number;
    Dati: DatiRCP.CRisAPIDatoTipiInfo_Comparatore;
    DatoRCPPolizza: any;
    AnagraficaJSON: Glob.DatiJSON;
    RecapitiJSON: Glob.DatiJSON;
    IndirizziJSON: Glob.DatiJSON;
    PolizzeJSON: Glob.DatiJSON;
    GaranzieJSON: Glob.DatiJSON;
    FileJSON: Glob.DatiJSON;
    Frazionamento: number;
    DatiProfessionaliJSON: Glob.DatiJSON;
    PreventivoSelezionato: boolean;
    Associati: DatiRCP.Associato[];
    ID_Polizza: number;
    ID_AnagPOS: number;
    Motivazione: string;
    QuestionnaireConfirmedSteps: string[];
    AreDetailsSaved: boolean;
    MaxClient: number;
    HasIntermediary: boolean;
    Intermediary: string;
    IgnoreDuplicates: boolean;
    BindingAuthority: string;
    Sottoscrittore: string;
    UwgLevel: string;
    DescrizioneRischio: string;
    EventualiAnomalie: string;
    PremioStandard: string;
    PremioProposto: string;
    MotivazioneGiuridica: string;
    HasTriedSave: boolean;

}

export class RCPComparatore extends BaseComponent<Glob.IRouteGlobaleProps, IRCPComparatoreState> {
    private _URLInfoPolizzaBase: string = "/api/polizza/GetInfoPolizza?ID_TipoProdotto=";
    private _URLInfoPolizza: string = this._URLInfoPolizzaBase + "0";
    private _Incremento: number = 0;
    private _CalcolaPolizze: number = -1;
    private _Polizze: DatiRCP.CRCPPolizze = new DatiRCP.CRCPPolizze();
    private _AbilitaModifica: boolean = true;
    private _TipoConsolidamento: string = "";
    private _Frazionamento: Dati.TDictTipo = {};
    private _ID_BinderCorretto: { [ID_BinderCompagnia: number]: number };

    //(this.state.Dati.Dato.ID_TipoPolizzaStato == undefined || this.state.Dati.Dato.ID_TipoPolizzaStato == "" || this.state.Dati.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_Preventivo)
    //TODO Usare questo nello stato o la variabile interna alla classe?
    private _Aggiornare: number = 1;

    constructor(props: any) {
        super(props);

        let studioAssociato: DatiRCP.Associato[] = [];
        let datiPolizzaBase: DatiRCP.CRisAPIDatoTipiInfo_Comparatore = new DatiRCP.CRisAPIDatoTipiInfo_Comparatore();

        if ((this.props.match.params as any).ID_Anag != undefined) {
            datiPolizzaBase.Dato.ID_AnagContraente = (this.props.match.params as any).ID_Anag;
        } else {
            datiPolizzaBase.Dato.ID_AnagContraente = 0;
        }

        this.state = {
            Caricamento: false,
            Aggiornare: 1,
            Dati: datiPolizzaBase,
            DatoRCPPolizza: {},
            AnagraficaJSON: "",
            RecapitiJSON: "",
            IndirizziJSON: "",
            PolizzeJSON: "",
            GaranzieJSON: "",
            FileJSON: "",
            Frazionamento: 12,
            DatiProfessionaliJSON: "",
            PreventivoSelezionato: false,
            Associati: studioAssociato,
            ID_Polizza: -1,
            ID_AnagPOS: Glob.GetSessione().ID_Anag,
            Motivazione: "",
            QuestionnaireConfirmedSteps: [],
            AreDetailsSaved: false,
            MaxClient: -1,
            HasIntermediary: false,
            Intermediary: "",
            IgnoreDuplicates: false,
            BindingAuthority: "",
            Sottoscrittore: "",
            UwgLevel: "",
            DescrizioneRischio: "",
            EventualiAnomalie: "",
            PremioStandard: "",
            PremioProposto: "",
            MotivazioneGiuridica: "",
            HasTriedSave: false
        };

        this.OnChange = this.OnChange.bind(this);
        this.OnChangeGaranzia = this.OnChangeGaranzia.bind(this);
        this.OnInvioCalcola = this.OnInvioCalcola.bind(this);
        this.OnChangeDataEffetto = this.OnChangeDataEffetto.bind(this);
        this.OnChangeImplantologiaOsteointegrata = this.OnChangeImplantologiaOsteointegrata.bind(this);
        this.RegoleCheck = this.RegoleCheck.bind(this);
        this.PopolaFrazionamento();
        this.OnErrore = this.OnErrore.bind(this);
        this.OnChangeAnagrafica = this.OnChangeAnagrafica.bind(this);
        this.OnClickSalvaAggiornamento = this.OnClickSalvaAggiornamento.bind(this);
        this.OnSaveDetails = this.OnSaveDetails.bind(this);
        this.ImpostaMenu();
    }

    static getDerivedStateFromProps(props: Glob.IRouteGlobaleProps, state: IRCPComparatoreState): IRCPComparatoreState {
        state.ID_Polizza = (props.match.params as any).ID_Polizza;
        return state;
    }

    private PopolaFrazionamento() {
        this._Frazionamento = {};
        this._Frazionamento["1"] = new Dati.CTipo("4", "Quadrimestrale");
        this._Frazionamento["2"] = new Dati.CTipo("6", "Semestrale");
        this._Frazionamento["3"] = new Dati.CTipo("12", "Annuale");
    }

    private GetPolicyInfo() {
        const Param: CChiamaWebParametri = {
            URL: `/api/polizza/GetPolicyInfo/?idPolicy=${this.state.ID_Polizza}`,
            OnRis: (sender, data) => {
                this.setState({
                    BindingAuthority: data.BindingAuthority,
                    Sottoscrittore: data.Sottoscrittore,
                    UwgLevel: data.UwgLevel,
                    DescrizioneRischio: data.DescrizioneRischio,
                    EventualiAnomalie: data.EventualiAnomalie,
                    PremioStandard: data.PremioStandard,
                    PremioProposto: data.PremioProposto,
                    MotivazioneGiuridica: data.MotivazioneGiuridica
                });
            },
            // OnErrore: (sender: ChiamaWeb, error: Error) => this.OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    }

    private GetPolicyInfoData(): any {
        let request = new Dati.CDatiPolicyInfo();

        request.ID_Polizza = this.state.ID_Polizza;
        request.BindingAuthority = this.state.BindingAuthority;
        request.Sottoscrittore = this.state.Sottoscrittore;
        request.UwgLevel = this.state.UwgLevel;
        request.DescrizioneRischio = this.state.DescrizioneRischio;
        request.EventualiAnomalie = this.state.EventualiAnomalie;
        request.PremioStandard = this.state.PremioStandard;
        request.PremioProposto = this.state.PremioProposto;
        request.MotivazioneGiuridica = this.state.MotivazioneGiuridica;

        return request;
    }

    private GetPolicyDataInfo(): { [I: string]: Dati.CInfoCampo } {
        const info: { [I: string]: Dati.CInfoCampo } = this.state.Dati.Info;

        {
            /*if (info.InformazioniPrecedentiAssicurativi) {
            let structure = JSON.parse(info.InformazioniPrecedentiAssicurativi.ParametriJSON);

            structure["DatiQuestionario"] = structure["DatiQuestionario"].map((item: Dati.CCampoStruttura) => {
                if (item.Campo == "DataScadenza") {
                    const policyStartDate = moment(this.state.Dati.Dato.DataEffetto);

                    item.Parametri = { DataMassima: policyStartDate.clone().add(1, "day").format("YYYY-MM-DD"), DataMinima: policyStartDate.clone().add(-1, "day").format("YYYY-MM-DD") };
                }
                return item;
            });

            info.InformazioniPrecedentiAssicurativi.ParametriJSON = JSON.stringify(structure);
        }*/
        }
        return info;
    }

    private OnChangeDataEffetto(e: React.FormEvent<any> | string, valore?: any): void {
        let DataEffetto: Data.CData = new Data.CData();
        let DataScadenza: Data.CData = new Data.CData();
        if (typeof e == "string") {
            DataEffetto = new Data.CData(valore);
        } else {
            DataEffetto = new Data.CData(e.currentTarget.value);
        }
        this._CalcolaPolizze++;
        DataScadenza = new Data.CData(DataEffetto.Data);
        DataScadenza.AddAnni(1);
        this.OnChange("Dato.DataFine", DataScadenza.Data);
        this.OnChange(e, valore);
    }

    private UpdateGuarantees(value: boolean, id: string, fieldName = ""): void {
        let guaranteesData: DatiRCP.CCampoGaranziaVisualizzazione[] = JSON.parse(this.state.GaranzieJSON);

        guaranteesData = guaranteesData.map((item: DatiRCP.CCampoGaranziaVisualizzazione) => {
            if (item.ID_TipoGaranzia == id) {
                item.Selezionata = value;
            }
            return item;
        });
        if (fieldName && !value && id == Glob.Tipi_RCPG_Accessoria_Sindaco) {
            ConnectedFields.forEach(field => {
                if (field.WarrantyId == Glob.Tipi_RCPG_Accessoria_Sindaco) {
                    const selectedFields = field.FieldsNames.filter(name => this.state.DatoRCPPolizza[name].RispostaAperturaQuestionario == true && name != fieldName);

                    if (!selectedFields.length) {
                        this.OnChangeGaranzia("GaranzieJSON", JSON.stringify(guaranteesData), fieldName);
                    }
                }
            });
        } else {
            this.OnChangeGaranzia("GaranzieJSON", JSON.stringify(guaranteesData), fieldName);
        }
    }

    private UpdateQuestionnaire(guarantees: DatiRCP.CCampoGaranziaVisualizzazione[], fieldName = ""): void {
        guarantees.forEach(item => {
            if (item.ID_TipoGaranzia == Glob.Tipi_RCPG_Accessoria_Implantologia && item.Selezionata != this.state.DatoRCPPolizza.implantologiaOsteointegrata) {
                this.OnChange("DatoRCPPolizza.implantologiaOsteointegrata", item.Selezionata);
                this.OnChangeImplantologiaOsteointegrata("", item.Selezionata);
            } else if (fieldName) {
                ConnectedFields.forEach((field: IConnectedField) => {
                    if (item.ID_TipoGaranzia == field.WarrantyId && field.FieldsNames.includes(fieldName) && item.Selezionata != this.state.DatoRCPPolizza[fieldName].RispostaAperturaQuestionario) {
                        let value: CCampiMultiInfoDati | string = "";
                        if (item.Selezionata) {
                            value = new CCampiMultiInfoDati();
                            value.RispostaAperturaQuestionario = true;
                        }

                        this.OnChange(`DatoRCPPolizza.${fieldName}`, value);
                    }
                });
            } else {
                ConnectedFields.forEach((field: IConnectedField) => {
                    if (item.ID_TipoGaranzia == field.WarrantyId) {
                        if (item.Selezionata) {
                            const notSelectedFields = field.FieldsNames.filter(name => !this.state.DatoRCPPolizza[name].RispostaAperturaQuestionario);
                            if (notSelectedFields.length == field.FieldsNames.length) {
                                const value: CCampiMultiInfoDati = new CCampiMultiInfoDati();
                                value.RispostaAperturaQuestionario = true;
                                this.OnChange(`DatoRCPPolizza.${field.FieldsNames[0]}`, value);
                            }
                        } else {
                            const selectedFields = field.FieldsNames.filter(name => this.state.DatoRCPPolizza[name].RispostaAperturaQuestionario == true);
                            if (selectedFields.length) {
                                field.FieldsNames.forEach(name => {
                                    this.OnChange(`DatoRCPPolizza.${name}`, "");
                                });
                            }
                            //console.warn("item.ID_TipoGaranzia", item.ID_TipoGaranzia);
                            //console.warn("field.WarrantyId", field.WarrantyId);
                        }
                    }
                });
            }
        });
    }

    private OnChangeImplantologiaOsteointegrata(e: React.FormEvent<any> | string, valore?: any): void {
        const TipoScoperto = JSON.parse(this.state.Dati.Info.TipoScoperto.TipoJSON);
        const keys = Object.keys(TipoScoperto).sort((a, b) => (Trad.Trad(a) < Trad.Trad(b) ? -1 : 1));

        keys.forEach(key => {
            TipoScoperto[key] = false;
        });
        if (valore) {
            TipoScoperto[keys[0]] = true;
        }
        this.OnChange("DatoRCPPolizza.TipoScoperto", TipoScoperto);
    }

    private OnChangeQuestionnaire(e: React.FormEvent<any> | string, valore?: any): void {
        let name = typeof e == "string" ? e : e.currentTarget.name || e.currentTarget.id;
        let confirmedSteps = this.state.QuestionnaireConfirmedSteps;
        let stepIndex = -1;

        name = name.split(".")[1];
        stepIndex = confirmedSteps.indexOf(this.state.Dati.Info[name].SottoGruppo);

        if (stepIndex >= 0) {
            confirmedSteps = confirmedSteps.splice(stepIndex, 1);
            this.setState({ QuestionnaireConfirmedSteps: confirmedSteps });
        }

        if (name == "implantologiaOsteointegrata") {
            this.OnChangeImplantologiaOsteointegrata(e, valore);
            this.UpdateGuarantees(valore, Glob.Tipi_RCPG_Accessoria_Implantologia);
        }
        ConnectedFields.forEach((field: IConnectedField) => {
            if (field.FieldsNames.includes(name)) {
                this.UpdateGuarantees(valore.RispostaAperturaQuestionario, field.WarrantyId, name);
            }
        });
        this._CalcolaPolizze++;
    }

    private OnRisDatiPolizzaNuova(sender: ChiamaAPI, dati: DatiRCP.CRisAPIDatoTipiInfo_Comparatore, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi && this.state.Dati.Dato.ID_Polizza == 0 /*&& this.state.Dati.Dato.ID_TipoProdotto > 0*/) {
            let datiPolizzaVuota: Dati.CRisAPIDatoTipiInfo_Polizza = new Dati.CRisAPIDatoTipiInfo_Polizza();
            datiPolizzaVuota.Info = dati.Info;
            datiPolizzaVuota.Dato = this.state.Dati.Dato;
            let nuovaPolizza: any = Glob.CreaClassePolizzaRCP(dati.Info);
            this.setState({
                Dati: datiPolizzaVuota,
                DatoRCPPolizza: nuovaPolizza,
                QuestionnaireConfirmedSteps: []
            });
        }

        return false;
    }

    private OnModificaURL(e: any, v: any): any {
        Glob.AvviaCaricamento(Trad.Trad("Caricamento dati polizza"));
        if (v != undefined && String(v) != "") {
            this._URLInfoPolizza = this._URLInfoPolizzaBase + String(v);
        } else {
            this._URLInfoPolizza = this._URLInfoPolizzaBase + "0";
        }

        if (v === "56") {
            let app: DatiRCP.CRisAPIDatoTipiInfo_Comparatore = this.state.Dati;
            app.Dato.ID_AnagContraente = 1294919;
            this.setState({ Dati: app });
        }

        this._Incremento = this._Incremento + 1;

        return v;
    }

    private OnRisAnagrafica(sender: ChiamaAPI, dati: Dati.CRisAPIDatoTipiInfo_Anag, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            if (dati.Dato.ID_Anag > 0) {
                if (dati.Dato.DataNascita && new Data.CDateTZLess(dati.Dato.DataNascita).IsGreaterThan(DatiRCP.MinDateOfBirth)) {
                    Glob.InfoModaleWarning(Trad.Trad("WARNING"), Trad.TradParam("La data non può essere posteriore il: {1-D}", [DatiRCP.MinDateOfBirth]));
                    dati.Dato.DataNascita = undefined;
                    if (this.state.AreDetailsSaved) {
                        this.setState({ AreDetailsSaved: false });
                    }
                }

                let maxClients: number = this.GetMaxClients(dati.Dato.ID_TipoAnagPrincipale);

                this.setState({
                    AnagraficaJSON: JSON.stringify(dati.Dato),
                    RecapitiJSON: dati.Dato.RecapitiJSON,
                    IndirizziJSON: dati.Dato.IndirizziJSON,
                    DatiProfessionaliJSON: dati.Dato.DatiProfessionaliJSON,
                    AreDetailsSaved: true,
                    HasTriedSave: true, 
                    MaxClient: maxClients
                });
            }
        }
        return false;
    }

    private OnSaveDetails = () => {
        this.setState({ AreDetailsSaved: true });
    };


    private OnFirstSaveAttempt = () => {
        this.setState({ HasTriedSave: true });
    };


    private PopolaProdotti(dati: DatiRCP.CRisAPIRCPInfo, saveCastelletto?: boolean): void {
        let prodotti: DatiRCP.CProdotto[] = [];
        if (dati.Polizze != undefined) {
            for (let i: number = 0; i < dati.Polizze.length; i++) {
                //Seleziono le polizze
                let prodotto: DatiRCP.CProdotto = new DatiRCP.CProdotto();
                //console.warn("dati.Polizze[i].Dati[0]", i, dati.Polizze[i].Dati[0]);
                prodotto.ID_Binder = dati.Polizze[i].Dati[0].ID_Binder;
                prodotto.ID_BinderCompagnia = dati.Polizze[i].Dati[0].ID_BinderCompagnia;
                prodotto.ID_AnagCompagniaBinder = dati.Polizze[i].Dati[0].ID_AnagCompagniaBinder;
                prodotto.Compagnia = dati.Polizze[i].Dati[0].Compagnia; //Garanzia base
                prodotto.Logo = "";
                prodotto.LimiteAccessori = dati.Polizze[i].Dati[0].LimiteAccessori;
                prodotto.LimiteFlessibilita = dati.Polizze[i].Dati[0].LimiteFlessibilita;
                prodotto.Scoperto = dati.Polizze[i].Dati[0].Scoperto;
                prodotto.ScopertoMin = dati.Polizze[i].Dati[0].ScopertoMin;
                prodotto.ScopertoMax = dati.Polizze[i].Dati[0].ScopertoMax;

                prodotto.PremioNettoMaggiorato = dati.Polizze[i].Dati[0].PremioNettoMaggiorato;
                prodotto.Accessori = dati.Polizze[i].Dati[0].Accessori;
                prodotto.Flessibilita = dati.Polizze[i].Dati[0].Flessibilita;

                let garanzia: DatiRCP.CGaranzia = new CGaranzia();
                garanzia.Abilitata = !dati.Polizze[i].Dati[0].Errore;
                //if (dati.Polizze[i].Dati[0].Semaforo == DatiRCP.SemaforoRosso) {
                //    garanzia.Abilitata = false;
                //}
                garanzia.Semaforo = dati.Polizze[i].Dati[0].Semaforo;
                garanzia.Base = true;
                garanzia.ID_TipoGaranzia = dati.Polizze[i].Dati[0].ID_TipoGaranzia;
                garanzia.NomeClasseGaranzia = dati.Polizze[i].Dati[0].NomeClasseGaranzia;
                garanzia.ImportoLordo = dati.Polizze[i].Dati[0].ImportoLordo;
                garanzia.ImportoNetto = dati.Polizze[i].Dati[0].ImportoNetto;
                garanzia.Messaggio = dati.Polizze[i].Dati[0].Messaggio;
                garanzia.Dati = dati.Polizze[i].Dati[0].Dati;

                prodotto.GaranziaBase = garanzia;
                prodotto.GaranzieAccessorie = [];

                for (let x: number = 1; x < dati.Polizze[i].Dati.length; x++) {
                    //Garanzie accessorie per questo parto da 1
                    let garanzia: DatiRCP.CGaranzia = new CGaranzia();
                    garanzia.Abilitata = !dati.Polizze[i].Dati[x].Errore;

                    //if (dati.Polizze[i].Dati[x].Semaforo == DatiRCP.SemaforoRosso) {
                    //    garanzia.Abilitata = false;
                    //}
                    garanzia.Semaforo = dati.Polizze[i].Dati[x].Semaforo;
                    garanzia.Base = false;
                    garanzia.ID_TipoGaranzia = dati.Polizze[i].Dati[x].ID_TipoGaranzia;
                    garanzia.NomeClasseGaranzia = dati.Polizze[i].Dati[x].NomeClasseGaranzia;
                    garanzia.ImportoLordo = dati.Polizze[i].Dati[x].ImportoLordo;
                    garanzia.ImportoNetto = dati.Polizze[i].Dati[x].ImportoNetto;
                    garanzia.Messaggio = dati.Polizze[i].Dati[x].Messaggio;
                    garanzia.Dati = dati.Polizze[i].Dati[x].Dati;
                    prodotto.GaranzieAccessorie.push(garanzia);

                }

                if ((prodotto.GaranziaBase.NomeClasseGaranzia === "AccelerantBelgio.PolizzaAreaMedicaGelli") || (prodotto.GaranziaBase.NomeClasseGaranzia === "SGI.PolizzaAreaMedicaGelli") || (prodotto.GaranziaBase.NomeClasseGaranzia === "AccelerantBelgio.PolizzaAreaMediciStudio")) {

                    let attivitaEsercitata: any = null;
                    attivitaEsercitata = this.state.DatoRCPPolizza.AttivitaEsercitata;
                    if (attivitaEsercitata.MedicinaLegale || attivitaEsercitata.MedicinaLavoro) {
                        dati.Garanzie[4].Selezionata = true;
                    }
                }
                if (prodotto.GaranziaBase.NomeClasseGaranzia === "SGI.PolizzaAreaMedicaXL")
                    prodotto.Accessori = 15;
                if (saveCastelletto) {
                    let tmpPolizze: DatiRCP.CProdotto[] = [];
                    if (typeof this.state.PolizzeJSON == "string") {
                        tmpPolizze = JSON.parse(this.state.PolizzeJSON);
                    } else {
                        tmpPolizze = this.state.PolizzeJSON;
                    }

                    let tmpPolizza: DatiRCP.CProdotto = new DatiRCP.CProdotto();
                    tmpPolizza = tmpPolizze[tmpPolizze.findIndex(p => p.ID_BinderCompagnia == dati.Polizze[i].Dati[0].ID_BinderCompagnia)];

                    if (
                        typeof tmpPolizza.CalcolaImportoNettoTotale == "function" &&
                        tmpPolizza.PremioNettoMaggiorato != tmpPolizza.CalcolaImportoNettoTotale() &&
                        tmpPolizza.PremioNettoMaggiorato > prodotto.CalcolaImportoNettoTotale()
                    )
                        //Lo tengo solo se era stato impostato dall'utente
                        prodotto.PremioNettoMaggiorato = tmpPolizza.PremioNettoMaggiorato;

                    prodotto.Accessori = tmpPolizza.Accessori;
                    prodotto.Flessibilita = tmpPolizza.Flessibilita;
                    //prodotto.PremioNettoMaggiorato = tmpPolizza.PremioNettoMaggiorato;
                    prodotto.GaranziaBase.Selezionata = tmpPolizza.GaranziaBase.Selezionata;
                }

                if (prodotto.GaranziaBase.NomeClasseGaranzia === "MARKEL.PolizzaVitaPrivata")
                    prodotto.Accessori = 10;

                prodotti.push(prodotto);
            }

            if (this._CalcolaPolizze < 0 && this.state.ID_Polizza == 0) {
                for (let i: number = 0; i < dati.Garanzie.length; i++) {
                    if (dati.Garanzie[i].ProprietaSelezione == "O" || dati.Garanzie[i].ProprietaSelezione == "P") {
                        dati.Garanzie[i].Selezionata = true;
                    }
                }
            }

            if (this.state.ID_Polizza == 0) {
                this.setState({
                    PolizzeJSON: JSON.stringify(prodotti),
                    GaranzieJSON: JSON.stringify(dati.Garanzie)
                });
            } else {
                this.setState({ PolizzeJSON: JSON.stringify(prodotti) });
            }
        }
    }

    private OnRisProdotto(sender: ChiamaAPI, dati: DatiRCP.CRisAPIRCPInfo, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            if (this.state.ID_Polizza == 0) {
                this.SetMaxClients();
                this.PopolaProdotti(dati, false);
            }
            //TODO Provo a correggere l'ID_Binder in DatiPolizza usando quello che arriva da /api/Polizza/GetGaranzieRCP (con l'ID del POS)
            const ID_BinderCorretto: { [ID_BinderCompagnia: number]: number } = {};
            for (let P = 0; P < dati.Polizze.length; P++) {
                if (dati.Polizze[P].Dati != null) {
                    for (let D = 0; D < dati.Polizze[P].Dati.length; D++) {
                        let ID_BinderCompagnia = dati.Polizze[P].Dati[D].ID_BinderCompagnia;
                        if (ID_BinderCompagnia > 0) {
                            ID_BinderCorretto[ID_BinderCompagnia] = dati.Polizze[P].Dati[D].ID_Binder;
                        }
                    }
                }
            }
            if (Object.keys(ID_BinderCorretto).length > 0) {
                this._ID_BinderCorretto = ID_BinderCorretto;
            }
        }
        console.warn("dati", dati);

        return false;
    }

    private OnRisCalcolaPolizze(sender: ChiamaAPI, dati: DatiRCP.CRisAPIRCPInfo, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            dati.Garanzie = JSON.parse(this.state.GaranzieJSON);
            if ((this.state.ID_Polizza == 0 && this._CalcolaPolizze >= 0) || this.state.ID_Polizza > 0) this.PopolaProdotti(dati, true);
        }
        return false;
    }

    private OnChangeGaranzia(e: React.FormEvent<any> | string, valore?: any, fieldName = ""): void {
        let garanzieApp: DatiRCP.CCampoGaranziaVisualizzazione[];

        if (valore == undefined) {
            garanzieApp = JSON.parse(this.state.GaranzieJSON);
        } else {
            garanzieApp = JSON.parse(valore);
            this.UpdateQuestionnaire(garanzieApp, fieldName);
        }
        this.PopolaGaranzie(garanzieApp);

        if (valore != undefined) {
            this.OnChange(e, valore);
        }
    }

    private PopolaGaranzie(garanzieApp: DatiRCP.CCampoGaranziaVisualizzazione[]) {
        this._Polizze = new DatiRCP.CRCPPolizze();
        let polizzeApp: DatiRCP.CProdotto[] = [];
        if (typeof this.state.PolizzeJSON == "string") polizzeApp = JSON.parse(this.state.PolizzeJSON);
        else polizzeApp = this.state.PolizzeJSON;

        for (let i: number = 0; i < polizzeApp.length; i++) {
            let polizzaApp: DatiRCP.CRCPPolizza = new DatiRCP.CRCPPolizza();

            //TODO Provo a correggere l'ID_Binder in DatiPolizza usando quello che arriva da /api/Polizza/GetGaranzieRCP (con l'ID del POS)
            if (this._ID_BinderCorretto != undefined && polizzeApp[i].ID_Binder == polizzeApp[i].ID_BinderCompagnia) {
                let ID_Binder = this._ID_BinderCorretto[polizzeApp[i].ID_BinderCompagnia];
                if (ID_Binder > 0) {
                    polizzaApp.ID_Binder = ID_Binder;
                    Glob.Log(Glob.LogCat.Form, false, "Binder corretto", polizzeApp[i].ID_BinderCompagnia, ID_Binder);
                }
            } else {
                polizzaApp.ID_Binder = polizzeApp[i].ID_Binder;
            }

            polizzaApp.ID_BinderCompagnia = polizzeApp[i].ID_BinderCompagnia;
            polizzaApp.ID_AnagCompagniaBinder = polizzeApp[i].ID_AnagCompagniaBinder;
            polizzaApp.Compagnia = polizzeApp[i].Compagnia;
            polizzaApp.ImportoLordo = polizzeApp[i].GaranziaBase.ImportoLordo;
            polizzaApp.ImportoNetto = polizzeApp[i].GaranziaBase.ImportoNetto;
            polizzaApp.ID_TipoGaranzia = polizzeApp[i].GaranziaBase.ID_TipoGaranzia;
            polizzaApp.NomeClasseGaranzia = polizzeApp[i].GaranziaBase.NomeClasseGaranzia;

            polizzaApp.LimiteAccessori = polizzeApp[i].LimiteAccessori;
            polizzaApp.LimiteFlessibilita = polizzeApp[i].LimiteFlessibilita;

            polizzaApp.Scoperto = polizzeApp[i].Scoperto;
            polizzaApp.ScopertoMin = polizzeApp[i].ScopertoMin;
            polizzaApp.ScopertoMax = polizzeApp[i].ScopertoMax;

            for (let x: number = 0; x < garanzieApp.length; x++) {
                if (garanzieApp[x].Selezionata) {
                    let garanziaApp: DatiRCP.CRCPGaranzia = new DatiRCP.CRCPGaranzia();
                    garanziaApp.ID_TipoGaranzia = garanzieApp[x].ID_TipoGaranzia;
                    garanziaApp.NomeClasseGaranzia = garanzieApp[x].NomeClasseGaranzia[polizzaApp.Compagnia];

                    polizzaApp.Garanzie.push(garanziaApp);
                }
            }

            this._Polizze.Polizze.push(polizzaApp);
        }
        this._CalcolaPolizze++;
    }

    private OnInvioCalcola(sender: ChiamaAPI): any {
        this._Polizze.Parametri = this.state.DatoRCPPolizza;
        //console.warn("this.state.Dato", this.state.Dati.Dato);
        //console.warn("this.state.Dato", this.state.DatoRCPPolizza);
        this._Polizze.Parametri["Frazionamento"] = this.state.Frazionamento;
        this._Polizze.Parametri["DataEffetto"] = this.state.Dati.Dato.DataEffetto;
        this._Polizze.Parametri["DataFine"] = this.state.Dati.Dato.DataFine;
        return this._Polizze;
    }

    private OnInvioSalva(sender: BottoneAPI): any {
        var Ingr = new Dati.CIngrAPITipi<Dati.CDatiAnag>();
        Ingr.Dato = JSON.parse(this.state.AnagraficaJSON);
        Ingr.Dato.IndirizziJSON = this.state.IndirizziJSON;
        Ingr.Dato.RecapitiJSON = this.state.RecapitiJSON;
        Ingr.Dato.DatiProfessionaliJSON = this.state.DatiProfessionaliJSON;
        return Ingr;
    }

    private OnInvioSalvaPolizza(sender: BottoneAPI): any {
        //console.warn("STATE", this.state);
        //this.RegoleCheck(this.state);
        //return false;
        if (this.state.Dati.Dato.ID_AnagContraente == 0) {
            Glob.InfoModaleWarning(Trad.Trad("POLIZZA"), Trad.Trad("SelezionareAnagraficaContraente"));
            return false;
        }

        if (this.state.Dati.Dato.ID_TipoProdotto == 0) {
            Glob.InfoModaleWarning(Trad.Trad("POLIZZA"), Trad.Trad("SelezionareProfessione"));
            return false;
        }

        if (!this.state.AreDetailsSaved) {
            Glob.InfoModaleWarning("WARNING", Trad.Trad("Save personal data"));
            return false;
        }

        var Ingr = new Dati.CIngrAPI<Dati.CDatiPolizza>();
        Ingr.Dato = this.state.Dati.Dato;
        Ingr.Dato.ID_AnagContraente = this.state.Dati.Dato.ID_AnagContraente;
        Ingr.Dato.ID_Polizza = this.state.ID_Polizza;
        Ingr.Dato.Intermediary = this.state.HasIntermediary ? this.state.Intermediary : undefined;

        if (this.state.Dati.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_ConsolidataSottoscrittore) Ingr.Dato.ID_TipoPolizzaStato = Glob.Tipi_PS_ConsolidataSottoscrittore;
        else Ingr.Dato.ID_TipoPolizzaStato = Glob.Tipi_PS_Preventivo;

        Ingr.Dato.ID_TipoRamo = Glob.TipiRami_RCP; //RCP

        if (Ingr.Dato.ID_AnagPOS == 0) {
            Ingr.Dato.ID_AnagPOS = this.state.ID_AnagPOS;
        }

        let DatiPolizza: DatiRCP.RCPPolizza = new DatiRCP.RCPPolizza();
        if (typeof this.state.DatoRCPPolizza == "string") DatiPolizza.DatoRCPPolizza = JSON.parse(this.state.DatoRCPPolizza);
        else DatiPolizza.DatoRCPPolizza = this.state.DatoRCPPolizza;

        if (typeof this.state.PolizzeJSON == "string") DatiPolizza.Polizze = JSON.parse(this.state.PolizzeJSON);
        else DatiPolizza.Polizze = this.state.PolizzeJSON;

        if (typeof this.state.GaranzieJSON == "string") DatiPolizza.Garanzie = JSON.parse(this.state.GaranzieJSON);
        else DatiPolizza.Garanzie = this.state.GaranzieJSON;

        DatiPolizza.Frazionamento = this.state.Frazionamento;

        Ingr.Dato.DatiPolizza = JSON.stringify(DatiPolizza);


        console.warn("STATE", this.state);
        return Ingr;
    }

    private OnConsolidaPolizza(sender: BottoneAPI, tipoConsolidamento: string): any {
        this._TipoConsolidamento = "";
        if (!this.RegoleCheck(this.state)) {
            var Ingr = new Dati.CIngrAPI<Dati.CDatiPolizza>();
            Ingr = this.OnInvioSalvaPolizza(sender);
            Ingr.Dato.ID_TipoPolizzaStato = tipoConsolidamento;
            Ingr.Dato.CoAssicurazioneJSON = "";
            this._TipoConsolidamento = tipoConsolidamento;
            return Ingr;
        } else {
            console.warn("this.state.Dati.Dato.ID_TipoProdotto", this.state.Dati.Dato.ID_TipoProdotto);
            return false;
        }
    }

    private OnClickSalvaPolizza(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            if (dati.ErrTesti = ["DataDecorrenzaOltreILimitiLGelli"]) {
                this.OnChange("Dato.DataEffetto", new Date());
                this.OnChange("Dato.DataFine", new Date());
            }
            Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
        } else {
            this.setState({ ID_Polizza: dati.ID_Chiave });
            this.state.Dati.Dato.Polizza = dati.MessaggioTesto; //Aggiorno il numero di polizza
            Glob.InfoModaleSuccess(Trad.Trad("POLIZZA"), Trad.TradParam("Preventivo salvato correttamente con ID: {1-S}", [dati.ID_Chiave]));

            if ((this.props.match.params as any).ID_Anag != undefined) {
                this.props.history.replace("/anagrafica/" + (this.props.match.params as any).ID_Anag + "/RCPComparatore/" + dati.ID_Chiave);
            } else {
                this.props.history.replace("/RCPComparatore/" + dati.ID_Chiave);
            }
        }
    }

    private OnClickSavePolicyInfo(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad(dati.ErrTesto) + (dati.ErrTesti.length > 0 ? " - " + dati.ErrTesti.join(", ") : ""));
        }
        else {
            Glob.InfoModaleSuccess("Info", Trad.Trad("Dati salvati correttamente"));
        }
    }

    private OnClickConsolidaPolizza(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad(dati.ErrTesto));
        } else {
            this.setState({ ID_Polizza: dati.ID_Chiave });
            let app: DatiRCP.CRisAPIDatoTipiInfo_Comparatore = this.state.Dati;
            app.Dato.Polizza = dati.MessaggioTesto; //Aggiorno il numero di polizza;
            if (this._TipoConsolidamento != "") app.Dato.ID_TipoPolizzaStato = this._TipoConsolidamento;
            //this.state.Dati.Dato.Polizza = dati.MessaggioTesto;  //Aggiorno il numero di polizza

            this.setState({ Dati: app });

            if ((this.props.match.params as any).ID_Anag != undefined) {
                //this.props.history.replace("/anagrafica/" + (this.props.match.params as any).ID_Anag + "/RCPComparatore/" + dati.ID_Chiave);
                this.props.history.push("/anagrafica/" + (this.props.match.params as any).ID_Anag + "/RCPPolizza/" + dati.ID_Chiave);
            } else {
                //this.props.history.replace("/RCPComparatore/" + dati.ID_Chiave);
                this.props.history.push("/RCPPolizza/" + dati.ID_Chiave);
            }
        }
    }

    private OnErroreBottoneAPI(sender: BottoneAPI, errore: Error) {
        Glob.InfoModaleError(Trad.Trad("ANAGRAFICA ERRORE"), errore.message);
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIDatoTipiInfo_Polizza, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            if (!dati.Errore) {
                if (dati.ID_Chiave > 0) {
                    let DatiApp: DatiRCP.CRisAPIDatoTipiInfo_Comparatore = new DatiRCP.CRisAPIDatoTipiInfo_Comparatore();
                    DatiApp.Dato.DatiPolizza = dati.Dato.DatiPolizza;
                    let nuovaPolizza: any = Glob.CreaClassePolizzaRCP(dati.Info);

                    let DatiPolizza: DatiRCP.RCPPolizza = new DatiRCP.RCPPolizza();
                    DatiPolizza = JSON.parse(dati.Dato.DatiPolizza);

                    if (DatiPolizza.DatoRCPPolizza.hasOwnProperty("Anagrafiche")
                        && DatiPolizza.DatoRCPPolizza.hasOwnProperty("NumeroAssicurati")) {
                        if (this.state.MaxClient != 1) {
                            DatiPolizza.DatoRCPPolizza.NumeroAssicurati = DatiPolizza.DatoRCPPolizza.Anagrafiche.length + 1;
                        }
                        else {
                            DatiPolizza.DatoRCPPolizza.NumeroAssicurati = 1;
                        }
                    }

                    this.setState(
                        {
                            Dati: dati,
                            ID_Polizza: dati.ID_Chiave,
                            DatoRCPPolizza: DatiPolizza.DatoRCPPolizza,
                            PolizzeJSON: JSON.stringify(DatiPolizza.Polizze),
                            GaranzieJSON: JSON.stringify(DatiPolizza.Garanzie),
                            FileJSON: dati.Dato.FileJSON,
                            ID_AnagPOS: dati.Dato.ID_AnagPOS,
                            Intermediary: dati.Dato.Intermediary == undefined ? "" : dati.Dato.Intermediary,
                            HasIntermediary: dati.Dato.Intermediary != undefined,
                        },
                        () => {
                            this.PopolaGaranzie(DatiPolizza.Garanzie);
                        }
                    );
                    this.GetPolicyInfo();
                }
            } else {
                Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
            }
        }
        return true;
    }

    private AbilitaModifica() {
        if (this.state.Dati.Tipi.PolizzaStato != undefined) {
            let Permesso: string[] = this.state.Dati.Tipi.PolizzaStato[Glob.Tipi_PS_Consolidata].Permesso || [];
            if (
                this.state.Dati.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_Preventivo ||
                (this.state.Dati.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_ConsolidataSottoscrittore && Permesso.indexOf(Glob.Tipi_PS_ConsolidataSottoscrittore) > -1)
            ) {
                this._AbilitaModifica = true;
            } else {
                this._AbilitaModifica = false;
            }
        }
    }

    private OnRisRegola(sender: ChiamaAPI, dati: Dati.CRisAPISemplice<string>, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this._Regole = dati.Dato;
        }
        return true;
    }

    private ImpostaMenu() {
        var M = Glob.GetMenu();
        if (this.state.Dati.Dato.ID_AnagContraente > 0) {
            M.ID_MenuMain = 10;
        } else {
            M.ID_MenuMain = 8;
        }
        M.Main = "Home";
        this.props.SetMenu(M);
    }

    private OnChangeAnagrafica(e: React.FormEvent<any> | string, valore?: any): void {
        if (typeof e == "string" && e == "Dato.ID_AnagContraente") {
            if (valore == 0 || valore == "") {
                this.OnChange("AnagraficaJSON", "");
                this.OnChange("DatiProfessionaliJSON", "");
                this.OnChange("IndirizziJSON", "");
                this.OnChange("RecapitiJSON", "");
            }
        }
        this.OnChange(e, valore);

        if (this.state.AreDetailsSaved) {
            this.setState({ AreDetailsSaved: false });
        }
    }

    private OnClickSalvaAggiornamento(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
        } else {
            Glob.InfoModaleSuccess(Trad.Trad("POLIZZA"), Trad.Trad("Stato aggiornato correttamente"));
        }
    }

    private OnClickCancel(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
        } else {
            Glob.InfoModaleSuccess(Trad.Trad("POLIZZA"), Trad.Trad("Preventivo cancellato correttamente con ID: {1-S}"));
            this.props.history.push("/");
        }
    }

    private OnStepConfirmation = (id: string) => {
        let confirmedSteps: string[] = this.state.QuestionnaireConfirmedSteps || [];

        confirmedSteps = confirmedSteps.concat(id);

        this.setState({ QuestionnaireConfirmedSteps: confirmedSteps });
    };

    private ValidateForm = (): boolean => {
        const Info = this.GetPolicyDataInfo();
        const addresses = this.state.IndirizziJSON && JSON.parse(this.state.IndirizziJSON);
        const professionalData = this.state.DatiProfessionaliJSON ? JSON.parse(this.state.DatiProfessionaliJSON) : {};
        const isAddressValid = !!(addresses?.length && addresses[0].Indirizzo && addresses[0].Citta);
        let isProfessionalDataValid = !!professionalData.AnnoInizioAttivita;

        let questionnaireSteps = Object.keys(Info)
            .filter(key => Info[key].Gruppo == "Livello3")
            .map(key => Info[key].SottoGruppo);

        questionnaireSteps = [...new Set(questionnaireSteps)];

        if (!ProductTypeIdsExceptions.includes(this.state.Dati.Dato.ID_TipoProdotto)) {
            isProfessionalDataValid = !!(isProfessionalDataValid && professionalData.NumeroIscrizione && professionalData.AnnoIscrizioneAlbo);
        }
        return isAddressValid && isProfessionalDataValid && this.state.QuestionnaireConfirmedSteps.length == questionnaireSteps.length;
    };


    private GetMaxClients = (idTipoAnagPrincipale: string): number => {
        let maxClients: number = -1;
        if (idTipoAnagPrincipale != "" && idTipoAnagPrincipale != Glob.Tipi_TAP_PersonaGiuridica) {
            let idTipoProdotto: number = this.state.Dati.Dato.ID_TipoProdotto;
            if (idTipoProdotto == 26 || idTipoProdotto == 27 || idTipoProdotto == 29 || idTipoProdotto == 50 || idTipoProdotto == 56) {
                maxClients = 1;
            }
        }
        return maxClients;
    }

    private SetMaxClients(): void {
        let maxClients: number = -1;
        if (this.state.AnagraficaJSON != "") {
            let DatiAnagrafica: Dati.CAnagrafica = new Dati.CAnagrafica();
            DatiAnagrafica = JSON.parse(this.state.AnagraficaJSON);
            maxClients = this.GetMaxClients(DatiAnagrafica.ID_TipoAnagPrincipale);
        }
        if (this.state.MaxClient != maxClients)
            this.setState({ MaxClient: maxClients });
    }

    public render() {
        if (!this.ControlloAutorizzazione("RCPComparatoreController")) {
            this.props.history.push("/ErroreAccesso");

            return false;

        }

        this.AbilitaModifica();
        const groups = Glob.GetSessione().Gruppi;

        let isUnderwriter: boolean = false;
        if (groups.indexOf("G&T") != -1 || groups.indexOf("16") != -1)
            isUnderwriter = true;

        if (!isUnderwriter && (this.state.Dati.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_Emessa ||
            this.state.Dati.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_Emessa_Firmata ||
            this.state.Dati.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_Approvata))
            this.props.history.push("/ErroreAccesso");

        const Info = this.GetPolicyDataInfo();
        let chiavi: number[] = [];

        chiavi.push(this.state.ID_Polizza);
        chiavi.push(this.state.Dati.Dato.ID_AnagContraente);

        let DatiAnagrafica: Dati.CAnagrafica = new Dati.CAnagrafica();
        if (this.state.AnagraficaJSON != "") {
            DatiAnagrafica = JSON.parse(this.state.AnagraficaJSON);
        }

        let ParametriAssociaPolizzaAPOS: { [Param: string]: any } = [];
        ParametriAssociaPolizzaAPOS["id_Polizza"] = this.state.ID_Polizza * 1;
        ParametriAssociaPolizzaAPOS["id_AnagPOS"] = this.state.ID_AnagPOS * 1;
        ParametriAssociaPolizzaAPOS["motivazione"] = this.state.Motivazione;


        console.warn("this.state.Dati.Dato", this.state.Dati.Dato);

        let datiPolizzaBase: DatiRCP.CRisAPIDatoTipiInfo_Comparatore = this.state.Dati;
        console.debug("###datiPolizzaBase", datiPolizzaBase);
        return (
            <div>
                <div className="kt-portlet">
                    <div className="kt-portlet__head">
                        <div className="kt-portlet__head-label">
                            <div className="kt-portlet__head-label">
                                <span className="kt-portlet__head-icon">
                                    <i className="fa fa-file-contract"></i>
                                </span>
                                <h3 className="kt-portlet__head-label">{Trad.Trad("Preventivatore RCP")}</h3>
                            </div>
                        </div>
                        <div className="portlet__head-tools">
                            <ul className="kt-portlet__nav">
                                <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true"></div>
                            </ul>
                        </div>
                    </div>
                    <form className="kt-form login-form kt-form login-form--label-align-left- kt-form login-form--state-" id="kt_form" noValidate>
                        <div className="kt-portlet__body">
                            <div className="kt-wizard__form-step kt-wizard__form-step--current"
                                id="kt_wizard_form_step_4">
                                <div className="row">
                                    <div className="col-xl-10 offset-xl-1">
                                        <div className="form-group kt-form login-form__group row">
                                            <div className={Glob.DimensioneCSS(11)}>
                                                <label className="form-control-label">{Trad.Trad("POS")}</label>
                                                <Tipo
                                                    URL="/api/Binder/AnagraficheConBinderVisibili"
                                                    Campo={"ID_AnagPOS"}
                                                    ID_Chiave={this.state.ID_AnagPOS}
                                                    OnAggiorna={(e, v) => {
                                                        this.OnChange(e, v);
                                                    }}
                                                    Disabilitato={this.state.ID_Polizza > 0 || !Glob.AzioneAbilitata("AssociaPolizzaAPOS", 2)}
                                                    TradValori
                                                />
                                            </div>
                                        </div>
                                        <div className="kt-form login-form__section kt-form login-form__section--first">
                                            <div className="kt-form login-form__heading">
                                                <h3 className="kt-form login-form__heading-title">{Trad.Trad("Information")}</h3>
                                            </div>
                                            <div className="form-group kt-form login-form__group row">
                                                <div className="col-lg-4 kt-form login-form__group-sub">
                                                    <label
                                                        className="form-control-label">{Trad.Trad("Professione")}</label>
                                                    <Tipo
                                                        Campo="Dato.ID_TipoProdotto"
                                                        ID_ChiaveString={this.state.Dati.Dato.ID_TipoProdotto.toString() || ""}
                                                        OnAggiorna={(e, v) => {
                                                            this.OnChange(e, this.OnModificaURL(e, v));
                                                        }}
                                                        URL="/api/Tipi/Tipo?tabella=TipiProdottiRC&campo=TipoProdotto&parametri=X"
                                                        Disabilitato={this.state.ID_Polizza > 0}
                                                        Ordinato={true}
                                                    />
                                                </div>
                                            </div>
                                            <CampiPolizza
                                                key={this.state.Dati.Dato.ID_TipoProdotto}
                                                Gruppo="Livello1"
                                                Riga={1}
                                                Info={Info}
                                                DatoPolizza={this.state.DatoRCPPolizza}
                                                Identificatore="DatoRCPPolizza"
                                                Limiti={{}}
                                                OnChange={(e, v) => {
                                                    this.OnChange(e, v);
                                                    this.OnChangeGaranzia(e, undefined);
                                                }}
                                                OnChangeDeroga={() => {
                                                }}
                                                OnBlur={() => {
                                                }}
                                                DimensioneGrafica={3}
                                                Abilitato={this._AbilitaModifica}
                                                MaxClient={this.state.MaxClient}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <br />

                                <div className="accordion accordion-solid accordion-toggle-plus" id="kt_accordion_1"
                                    role="tablist">
                                    <div className="card">
                                        <AccordionGaranzie
                                            Name="GaranzieJSON"
                                            Id="GaranzieJSON"
                                            Value={this.state.GaranzieJSON}
                                            OnChange={this.OnChangeGaranzia}
                                            Abilitato={this._AbilitaModifica}
                                            Indice={1}
                                        />
                                    </div>
                                    <div className="card">
                                        <AccordionProdotti
                                            Id="PolizzeJSON"
                                            Name="PolizzeJSON"
                                            OnChange={(e, v) => {
                                                this.OnChange(e, v);
                                            }}
                                            Value={this.state.PolizzeJSON}
                                            Abilitato={this._AbilitaModifica}
                                            CampoPreventivoSelezionato="PreventivoSelezionato"
                                            Indice={2}
                                            Forzabili={this.state.Dati.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_ConsolidataSottoscrittore}
                                        />
                                    </div>
                                    <div className="card overflow-visible">
                                        <AccordionCampiPolizza
                                            key={this.state.Dati.Dato.ID_TipoProdotto}
                                            Gruppo="Livello3"
                                            Riga={3}
                                            Info={Info}
                                            DatoPolizza={this.state.DatoRCPPolizza}
                                            Identificatore="DatoRCPPolizza"
                                            Limiti={{}}
                                            OnChange={(e, v) => {
                                                this.OnChangeQuestionnaire(e, v);
                                                this.OnChange(e, v);
                                                this.OnChangeGaranzia(e, undefined);
                                            }}
                                            OnChangeDeroga={() => {
                                            }}
                                            OnBlur={() => {
                                            }}
                                            DimensioneGrafica={6}
                                            Abilitato={this._AbilitaModifica}
                                            Indice={3}
                                            ConfirmedSteps={this.state.QuestionnaireConfirmedSteps}
                                            OnStepConfirmation={this.OnStepConfirmation}
                                            MaxClient={this.state.MaxClient}
                                        />
                                    </div>
                                    <div className="card overflow-visible">
                                        <AccordionAnagrafica
                                            AnagraficaJSON={this.state.AnagraficaJSON}
                                            AnagraficaId="AnagraficaJSON"
                                            AnagraficaName="AnagraficaJSON"
                                            DatiProfessionaliJSON={this.state.DatiProfessionaliJSON}
                                            DatiProfessionaliId="DatiProfessionaliJSON"
                                            DatiProfessionaliName="DatiProfessionaliJSON"
                                            IndirizziJSON={this.state.IndirizziJSON}
                                            IndirizziId="IndirizziJSON"
                                            IndirizziName="IndirizziJSON"
                                            RecapitiJSON={this.state.RecapitiJSON}
                                            RecapitiId="RecapitiJSON"
                                            RecapitiName="RecapitiJSON"
                                            OnChange={this.OnChangeAnagrafica}
                                            OnSaveDetails={this.OnSaveDetails}
                                            Indice={4}
                                            Id="Anagrafica"
                                            Name="Anagrafica"
                                            CampoTipo="Dato.ID_AnagContraente"
                                            ID_AnagContraente={this.state.Dati.Dato.ID_AnagContraente}
                                            ID_TipoProdotto={this.state.Dati.Dato.ID_TipoProdotto}
                                            CampoIDAnagrafica="Dati.Dato.ID_AnagContraente"
                                            ID_TipoAnagPrincipale="DatiAnagrafica.ID_TipoAnagPrincipale"
                                            StatoAnagrafica={Glob.Tipi_AS_Attivo}
                                            OnFirstSaveAttempt={this.OnFirstSaveAttempt}
                                            HasTriedSave={this.state.HasTriedSave}
                                        />
                                    </div>
                                    <div className="card overflow-visible">
                                        <div className="card-header">
                                            <a
                                                href="#kt_accordion_1_item_5_body"
                                                className="card-title collapsed"
                                                role="tab"
                                                id="kt_accordion_1_item_5_head"
                                                data-toggle="collapse"
                                                aria-expanded="false"
                                            >
                                                <span className="accordion__item-icon">
                                                    <i className="fa fa-feather-alt"></i>
                                                </span>
                                                <span
                                                    className="accordion__item-icon">{Trad.Trad("DatiEmissione")}</span>
                                                <span className="kt-accordion__item-mode"></span>
                                            </a>
                                            <div
                                                className="kt-accordion__itekt-body collapse spazioVerticale"
                                                id="kt_accordion_1_item_5_body"
                                                role="tabpanel"
                                                aria-labelledby="kt_accordion_1_item_5_head"
                                                data-parent="#kt_accordion_1"
                                            >
                                                <div className="tab-content kt--padding-30">
                                                    <div
                                                        className="form-group special-group kt-form login-form__group row">
                                                        <div
                                                            className={Glob.DimensioneCSS(4) + " kt-form login-form__group-sub"}>
                                                            <InputData
                                                                ValoreInArrivo={this.state.ID_Polizza > 0}
                                                                Name="Dato.DataEffetto"
                                                                Id="Dato.DataEffetto"
                                                                Valore={this.state.Dati.Dato.DataEffetto}
                                                                OnChange={this.OnChangeDataEffetto}
                                                                Etichetta="DataEffetto"
                                                                DataMinima={moment().add(-30, "day").toDate()}
                                                                DataMassima={moment().add(365, "day").toDate()}
                                                            />
                                                        </div>
                                                        <div
                                                            className={Glob.DimensioneCSS(4) + " kt-form login-form__group-sub"}>
                                                            <InputData
                                                                ValoreInArrivo={this.state.ID_Polizza > 0}
                                                                Name="Dato.DataFine"
                                                                Id="Dato.DataFine"
                                                                Valore={this.state.Dati.Dato.DataFine}
                                                                OnChange={this.OnChange}
                                                                Etichetta="DataScadenza"
                                                                Scrittura={groups.indexOf("16") != -1}
                                                                readonly={groups.indexOf("16") != -1}
                                                            />
                                                        </div>
                                                        <div
                                                            className={Glob.DimensioneCSS(4) + " kt-form login-form__group-sub"}>
                                                            <label className="">{Trad.Trad("Frazionamento")}</label>
                                                            <Tipo
                                                                Campo="Frazionamento"
                                                                ID_ChiaveString={this.state.Frazionamento.toString() || ""}
                                                                OnAggiorna={(e, v) => {
                                                                    this.OnChange(e, v);
                                                                    this.OnChangeGaranzia(e, undefined);
                                                                    this._CalcolaPolizze++;
                                                                }}
                                                                Dati={this._Frazionamento}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <br />
                                        <div
                                            className={!Glob.AzioneAbilitata("AssociaPolizzaAPOS", 2) || this.state.ID_Polizza <= 0 ? "hidden" : "form-group kt-form login-form__group row"}>
                                            <div className={Glob.DimensioneCSS(12)}>
                                                <div className="drop-document kt-portlet kt-portlet--height-fluid">
                                                    <div className="kt-portlet__head">
                                                        <div className="kt-portlet__head-label">
                                                            <h3 className="kt-portlet__head-title">{Trad.Trad("Operazioni")}</h3>
                                                        </div>
                                                    </div>
                                                    <div className="kt-portlet__body">
                                                        <div className="kt-widget4">
                                                            <div className="row">
                                                                <div
                                                                    className={Glob.DimensioneCSS(2)}>{Trad.Trad("AssociaPolizzaAPOS")}</div>
                                                                <div className={Glob.DimensioneCSS(4)}>
                                                                    <Tipo
                                                                        URL="/api/Binder/AnagraficheConBinderVisibili"
                                                                        Campo={"ID_AnagPOS"}
                                                                        ID_Chiave={this.state.ID_AnagPOS}
                                                                        OnAggiorna={(e, v) => {
                                                                            this.OnChange(e, v);
                                                                        }}
                                                                        TradValori
                                                                        LinkSelezione="/anagrafica/"
                                                                    />
                                                                </div>
                                                                <div className={Glob.DimensioneCSS(4)}>
                                                                    <textarea className="form-control"
                                                                        name="Motivazione"
                                                                        value={this.state.Motivazione} rows={4}
                                                                        onChange={this.OnChange}></textarea>
                                                                </div>
                                                                <div className={Glob.DimensioneCSS(2)}>
                                                                    <BottoneAPI
                                                                        Attivo={this.state.Dati.Dato.ID_TipoPolizzaStato != Glob.Tipi_PS_Emessa}
                                                                        Alt={Trad.Trad("Associa")}
                                                                        Icona="fa fa-exchange-alt"
                                                                        Testo={Trad.Trad("Associa")}
                                                                        ClasseAttivo="btn btn-warning"
                                                                        ClasseAttesa="btn kt-btn btn-warning kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                                                        URL="/api/polizza/AssociaPolizzaAPOS"
                                                                        Metodo="POST"
                                                                        OnClick={(s, d) => this.OnClickSalvaAggiornamento(s, d)}
                                                                        ParamURLLista={ParametriAssociaPolizzaAPOS}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="row mb-3 pb-3"
                                                                style={{ borderBottom: "1px dashed #ebedf2" }}>
                                                                <div className={Glob.DimensioneCSS(12)}>
                                                                    {Trad.Trad("IgnoreDuplicates")}
                                                                    <div className="kt-radio-list">
                                                                        <div className="row ml-1">
                                                                            <label
                                                                                className="kt-radio kt-radio--solid kt-radio--state-success">
                                                                                <input name="rdo1Si" type="radio"
                                                                                    checked={this.state.IgnoreDuplicates}
                                                                                    onClick={() => {
                                                                                        this.setState({ IgnoreDuplicates: true })
                                                                                    }} />{Trad.Trad("Si")} <span />
                                                                            </label>
                                                                            <label
                                                                                className="kt-radio kt-radio--solid kt-radio--state-success ml-4">
                                                                                <input name="rdo1No" type="radio"
                                                                                    checked={!this.state.IgnoreDuplicates}
                                                                                    onClick={() => {
                                                                                        this.setState({ IgnoreDuplicates: false });
                                                                                    }} />{Trad.Trad("No")}<span />
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group kt-form login-form__group row">
                                    <div className={Glob.DimensioneCSS(12)}>
                                        <div className="drop-document kt-portlet kt-portlet--height-fluid">
                                            <div className="kt-portlet__head">
                                                <div className="kt-portlet__head-label">
                                                    <h3 className="kt-portlet__head-title">{Trad.Trad("Rete distributiva")}</h3>
                                                </div>
                                            </div>
                                            <div className="kt-portlet__body">
                                                <div className="row ">
                                                    <div className={Glob.DimensioneCSS(5)}>
                                                        <label>{Trad.Trad("Per questa polizza ti sei avvalso della collaborazione di un altro intermediario assicurativo (iscritto in sezione A o B del RUI)?")}</label>
                                                    </div>
                                                    <div className={Glob.DimensioneCSS(3)}>
                                                        <div className="kt-radio-list">
                                                            <div className="row ml-1">
                                                                <label
                                                                    className="kt-radio kt-radio--solid kt-radio--state-success">
                                                                    <input name="rdoSi" type="radio"
                                                                        checked={this.state.HasIntermediary}
                                                                        onClick={() => {
                                                                            this.setState({ HasIntermediary: true })
                                                                        }} />{Trad.Trad("Si")} <span />
                                                                </label>
                                                                <label
                                                                    className="kt-radio kt-radio--solid kt-radio--state-success ml-4">
                                                                    <input name="rdoNo" type="radio"
                                                                        checked={!this.state.HasIntermediary}
                                                                        onClick={() => {
                                                                            this.setState({ HasIntermediary: false });
                                                                            this.setState({ Intermediary: "" })
                                                                        }} />{Trad.Trad("No, è un cliente diretto")}<span />
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={Glob.DimensioneCSS(3)}>
                                                        {(this.state.HasIntermediary) ?
                                                            <>
                                                                <label>{Trad.Trad("Nome del Intermediario")}</label>
                                                                <input type="text"
                                                                    className="form-control"
                                                                    name="Intermediary"
                                                                    value={this.state.HasIntermediary ? this.state.Intermediary : ""}
                                                                    onChange={(e) => this.setState({ Intermediary: e.currentTarget.value })}>
                                                                </input>
                                                            </>
                                                            : <div />
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className={Glob.GetSessione().Autorizzazioni['CampoNoteRationale'] != 2 ? "hidden" : "form-group kt-form login-form__group row"}>
                                    <div className={Glob.DimensioneCSS(12)}>
                                        <div className="drop-document kt-portlet kt-portlet--height-fluid">
                                            <div className="kt-portlet__head">
                                                <div className="kt-portlet__head-label">
                                                    <h3 className="kt-portlet__head-title">{Trad.Trad("Campo note rationale")}</h3>
                                                </div>
                                            </div>
                                            <div className="kt-portlet__body">
                                                <div className="kt-widget4">
                                                    <div className="row ">
                                                        <div className={Glob.DimensioneCSS(12)}>
                                                            <label>{Trad.Trad("Binding Authority")}</label>
                                                        </div>
                                                        <div className={Glob.DimensioneCSS(12)}>
                                                            <input type="text"
                                                                className="form-control"
                                                                name="BindingAuthority"
                                                                value={this.state.BindingAuthority}
                                                                onChange={(e) => this.setState({ BindingAuthority: e.currentTarget.value })}>
                                                            </input>
                                                        </div>
                                                    </div>
                                                    <div className="row ">
                                                        <div className={Glob.DimensioneCSS(6)}>
                                                            <label>{Trad.Trad("Sottoscrittore")}</label>
                                                        </div>
                                                        <div className={Glob.DimensioneCSS(6)}>
                                                            <label>{Trad.Trad("Uwg level of authority")}</label>
                                                        </div>
                                                        <div className={Glob.DimensioneCSS(6)}>
                                                            <input type="text"
                                                                className="form-control"
                                                                name="Sottoscrittore"
                                                                value={this.state.Sottoscrittore}
                                                                onChange={(e) => this.setState({ Sottoscrittore: e.currentTarget.value })}>
                                                            </input>
                                                        </div>
                                                        <div className={Glob.DimensioneCSS(6)}>
                                                            <input type="text"
                                                                className="form-control"
                                                                name="UwgLevel"
                                                                value={this.state.UwgLevel}
                                                                onChange={(e) => this.setState({ UwgLevel: e.currentTarget.value })}>
                                                            </input>
                                                        </div>
                                                    </div>
                                                    <div className="row ">
                                                        <div className={Glob.DimensioneCSS(6)}>
                                                            <label>{Trad.Trad("Descrizione rischio assicurato")}</label>
                                                        </div>
                                                        <div className={Glob.DimensioneCSS(6)}>
                                                            <label>{Trad.Trad("Eventuali anomalie della proposta rispetto alle UWG")}</label>
                                                        </div>
                                                        <div className={Glob.DimensioneCSS(6)}>
                                                            <textarea className="form-control"
                                                                name="DescrizioneRischio"
                                                                value={this.state.DescrizioneRischio} rows={4}
                                                                onChange={(e) => this.setState({ DescrizioneRischio: e.currentTarget.value })} />
                                                        </div>
                                                        <div className={Glob.DimensioneCSS(6)}>
                                                            <textarea className="form-control"
                                                                name="EventualiAnomalie"
                                                                value={this.state.EventualiAnomalie} rows={4}
                                                                onChange={(e) => this.setState({ EventualiAnomalie: e.currentTarget.value })} />
                                                        </div>
                                                    </div>
                                                    <div className="row ">
                                                        <div className={Glob.DimensioneCSS(3)}>
                                                            <label>{Trad.Trad("Premio standard")}</label>
                                                        </div>
                                                        <div className={Glob.DimensioneCSS(3)}>
                                                            <label>{Trad.Trad("Premio proposto (se diverso dallo standard)")}</label>
                                                        </div>
                                                        <div className={Glob.DimensioneCSS(6)} />
                                                        <div className={Glob.DimensioneCSS(3)}>
                                                            <input type="text"
                                                                className="form-control"
                                                                name="PremioStandard"
                                                                value={this.state.PremioStandard}
                                                                onChange={(e) => this.setState({ PremioStandard: e.currentTarget.value })}>
                                                            </input>
                                                        </div>
                                                        <div className={Glob.DimensioneCSS(3)}>
                                                            <input type="text"
                                                                className="form-control"
                                                                name="PremioProposto"
                                                                value={this.state.PremioProposto}
                                                                onChange={(e) => this.setState({ PremioProposto: e.currentTarget.value })}>
                                                            </input>
                                                        </div>
                                                        <div className={Glob.DimensioneCSS(6)} />
                                                    </div>

                                                    <div className="row ">
                                                        <div className={Glob.DimensioneCSS(12)}>
                                                            <label>{Trad.Trad("Motivazione giuridica, tecnica e/o commerciale per le deroghe applicate")}</label>
                                                        </div>
                                                        <div className={Glob.DimensioneCSS(10)}>
                                                            <textarea className="form-control"
                                                                name="MotivazioneGiuridica"
                                                                value={this.state.MotivazioneGiuridica}
                                                                rows={4}
                                                                onChange={(e) => this.setState({ MotivazioneGiuridica: e.currentTarget.value })} />
                                                        </div>
                                                        <div className={Glob.DimensioneCSS(2)}>
                                                            <BottoneAPI
                                                                Alt={Trad.Trad("Salva")}
                                                                Icona="fa fa-save"
                                                                Testo={Trad.Trad("Salva")}
                                                                ClasseAttivo="btn btn-brand"
                                                                ClasseAttesa="btn kt-btn btn-brand kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                                                URL="/api/polizza/savepolicyinfo"
                                                                Metodo="POST"
                                                                OnInvio={s => this.GetPolicyInfoData()}
                                                                OnClick={(s, d) => this.OnClickSavePolicyInfo(s, d)}
                                                                //OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)}
                                                                Visibile={this._Scrittura}

                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="kt-portlet__foot kt-portlet__foot--fit">
                            <div className="kt-form login-form__actions kt-form login-form__actions--left">
                                <div className="col kt-form__actions kt-form__actions--left">
                                    <div className="col-lg-12 kt--align-left">
                                        <div className="divtabella">
                                            <BottoneAPI
                                                Attivo={this._AbilitaModifica && this.ValidateForm()}
                                                Alt={Trad.Trad("Salva")}
                                                Icona="fa fa-save"
                                                Testo={Trad.Trad("Salva")}
                                                ClasseAttivo="btn btn-brand"
                                                ClasseAttesa="btn kt-btn btn-brand kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                                URL={"/api/polizza/salvapolizza?ignoreDuplicates=" + this.state.IgnoreDuplicates}
                                                Metodo="POST"
                                                OnInvio={s => this.OnInvioSalvaPolizza(s)}
                                                OnClick={(s, d) => this.OnClickSalvaPolizza(s, d)}
                                                OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)}
                                                Visibile={this._Scrittura}
                                            />
                                        </div>
                                        <div className="divtabella">
                                            <BottoneAPI
                                                Attivo={this.state.Dati.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_Preventivo}
                                                Alt={Trad.Trad("Consolida sottoscrittore")}
                                                Icona="fa fa-book-reader"
                                                Testo={Trad.Trad("Consolida sottoscrittore")}
                                                ClasseAttivo="btn btn-warning"
                                                ClasseAttesa="btn kt-btn btn-brand kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                                URL={"/api/polizza/salvapolizza?ignoreDuplicates=" + this.state.IgnoreDuplicates}
                                                Metodo="POST"
                                                OnInvio={s => this.OnConsolidaPolizza(s, Glob.Tipi_PS_ConsolidataSottoscrittore)}
                                                OnClick={(s, d) => this.OnClickConsolidaPolizza(s, d)}
                                                OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)}
                                                Visibile={this._Scrittura && this.state.Dati.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_Preventivo}
                                            />
                                        </div>
                                        <div className="divtabella">
                                            <BottoneAPI
                                                Attivo={this.state.Dati.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_Preventivo || this._AbilitaModifica}
                                                Alt={Trad.Trad("Consolida compagnia")}
                                                Icona="fa fa-inbox"
                                                Testo={Trad.Trad("Consolida compagnia")}
                                                ClasseAttivo="btn btn-success"
                                                ClasseAttesa="btn kt-btn btn-brand kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                                URL={"/api/polizza/salvapolizza?ignoreDuplicates=" + this.state.IgnoreDuplicates}
                                                Metodo="POST"
                                                OnInvio={s => this.OnConsolidaPolizza(s, Glob.Tipi_PS_Consolidata)}
                                                OnClick={(s, d) => this.OnClickConsolidaPolizza(s, d)}
                                                OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)}
                                                Visibile={
                                                    this._Scrittura &&
                                                    (this.state.Dati.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_Preventivo ||
                                                        this.state.Dati.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_ConsolidataSottoscrittore)
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="kt-form login-form__actions kt-form login-form__actions--left">
                                <div className="col kt-form__actions kt-form__actions--left">
                                    <div className="col-lg-12 kt--align-left">
                                        <div className="divtabella">
                                            <BottoneAPI
                                                Attivo={this.state.Dati.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_Preventivo || this._AbilitaModifica}
                                                Alt={Trad.Trad("Cancella")} Icona="fa fa-times-circle"
                                                Testo={Trad.Trad("Cancella")} ClasseAttivo="btn btn-danger"
                                                ClasseAttesa="btn kt-btn btn-brand kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                                URL={"/api/polizza/ChangeStateToDraft?id_Polizza=" + this.state.Dati.Dato.ID_Polizza + "&allRecords=true"}
                                                Metodo="POST"
                                                OnClick={(s, d) => this.OnClickCancel(s, d)}
                                                OnErrore={(s, e) => this.OnErrore(s, e)}
                                                Visibile={this._Scrittura && (this.state.Dati.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_Preventivo
                                                    || this.state.Dati.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_ConsolidataSottoscrittore)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <ChiamaAPI Aggiornare={this._Incremento} URL={this._URLInfoPolizza}
                            OnRis={(s, d, dn) => this.OnRisDatiPolizzaNuova(s, d, dn)} OnErrore={this.OnErrore} />
                        <ChiamaAPI
                            Aggiornare={this.state.Dati.Dato.ID_AnagContraente}
                            URL={"/api/anag/seleziona?id_Anag=" + this.state.Dati.Dato.ID_AnagContraente}
                            OnRis={(s, d, dn) => this.OnRisAnagrafica(s, d, dn)}
                            OnErrore={this.OnErrore}
                        />
                        <ChiamaAPI
                            Aggiornare={this.state.Dati.Dato.ID_TipoProdotto}
                            URL={"/api/Polizza/GetGaranzieRCP?ID_TipoProdotto=" + this.state.Dati.Dato.ID_TipoProdotto + "&ID_AnagPOS=" + this.state.ID_AnagPOS}
                            OnRis={(s, d, dn) => this.OnRisProdotto(s, d, dn)}
                            OnErrore={this.OnErrore}
                        />
                        <ChiamaAPI
                            Aggiornare={this._CalcolaPolizze}
                            URL={"/api/Polizza/CalcolaPreventiviRCP"}
                            OnInvio={s => this.OnInvioCalcola(s)}
                            OnRis={(s, d, dn) => this.OnRisCalcolaPolizze(s, d, dn)}
                            OnErrore={this.OnErrore}
                        />
                        <ChiamaAPI
                            Aggiornare={this._Aggiornare}
                            URL={"/api/polizza/?id_Polizza=" + this.state.ID_Polizza + "&id_AnagContraente=" + this.state.Dati.Dato.ID_AnagContraente}
                            OnRis={(s, d, dn) => this.OnRis(s, d, dn)}
                            OnErrore={this.OnErrore}
                        />
                        <ChiamaAPI
                            Aggiornare={this.state.Dati.Dato.ID_TipoProdotto}
                            URL={"/api/regole/Get?id_Regola=Regola" + this.state.Dati.Dato.ID_TipoProdotto.toString()}
                            OnRis={(s, d, dn) => this.OnRisRegola(s, d, dn)}
                            OnErrore={this.OnErrore}
                        />
                        <input type="checkbox" name="PreventivoSelezionato" id="PreventivoSelezionato"
                            className="hidden" readOnly={true} checked={this.state.PreventivoSelezionato} />
                    </form>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/form/RCPComparatore.tsx